import { FunctionComponent, useEffect, useState } from "react";
import "react-image-gallery/styles/css/image-gallery.css";
import { Navigate, useLocation } from "react-router-dom";
import PropertyDesc from "./property-desc";
import { getPropertiesById, UpdatePropertyService } from "../../Services/Properties";
import ListImageGallery from "../listing-ceation/MarketingAssests/list-image-gallery";
import EditListing from "../edit-listing/edit-listing";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import DownloadProperty from "./download-property";
import { PropertyDetailsObj } from "../../Models/PropertyDetailsObj";
import Share from "./share";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import { fetchAccessData } from "../store/Access-Right-Slice";
import { DialogTitle, IconButton, DialogContent, styled, Dialog } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import UpgradeDetails from "../Layout/upgrade-details";
import { useTranslation } from "react-i18next";
import PropertyWidget from "../widget/enhance-widget";
import DescriptionWidget from "../widget/desc-title-widget";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const PropertyDetails: FunctionComponent<{}> = (props) => {

    let location = useLocation();
    const idValue = location.pathname.split('/');
    const [property, setProperty] = useState<PropertyDetailsObj | undefined>(undefined);
    const [loading, setLoading] = useState(true);
    const [isChange, setIsChange] = useState<boolean>(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [message, setMessage] = useState<string>();
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [selectedLang, setSelectedLang] = useState("");
    const dispatch = useDispatch<AppDispatch>();
    const accessValue = useSelector((state: RootState) => state.AccessRight.accessValue) as Record<string, boolean>;
    const [showUpgrade, setShowUpgrade] = useState(false);
    const { t } = useTranslation();
    const [error, setError] = useState(false);

    useEffect(() => {
        dispatch(fetchAccessData());
    }, [dispatch]);

    useEffect(() => {
        const id: any = idValue[2];
        getPropertiesById(id).then((data) => {
            setProperty(data)
            setLoading(false);
            setSelectedLang(data.content.description[0]?.lang);
        }).catch((error) => {
            setError(true);
            console.log(error)
        })

    }, [isChange])

    const UpdatePropertyHandler = (property: any, id: any) => {
        UpdatePropertyService(property, id).then((data) => {
            setMessage("Property Updated Successfully !");
            setIsChange(!isChange)
            setColorSnackbar("success")
            setOpenSnackbar(true)
        }).catch((error: any) => {
            setColorSnackbar("error")
            setOpenSnackbar(true)
            setMessage("Failed to update property.")
        })

    }

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const HandlePropertyReport = () => {
        if (!accessValue.pdfReport) {
            setShowUpgrade(true);
        } else {
            window.open(`/create-property-report/${idValue[2]}`, '_blank');
        }
    }
    if (error) {
        return <Navigate to="/404" replace />;
    }

    const handleImagesChange = (images: any) => {
        console.log("Images from widget:", images);
    }

    return loading ? (<div className="container-xxl flex-grow-1 container-p-y"> Loading ...</div>) : (
        <div className="container-xxl flex-grow-1 padd-bottom-80">
            <div className="row ">
                <div className="col-md-3 mb-4">
                    <a className="button-dash padd-15  bold-600 reoder back-238-242 border-12 border-trans" href={"/properties"}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_830_5372)">
                                <path d="M19 12H5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M19 12H5" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11 18L5 12" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11 18L5 12" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11 6L5 12" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M11 6L5 12" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_830_5372">
                                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                                </clipPath>
                            </defs>
                        </svg>
                        {t("sidebar.myProperties")}
                    </a>
                </div>
                <div className="col-md-9 mb-4 d-flex align-items-center justify-content-end">
                    <button className="button-reset border-4F52C1 border-6 back-E0E7FF color-4F52C1 bold-700 padd-5-mb padd-15-30 marg-right-16" onClick={HandlePropertyReport}>
                        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_830_5367)">
                                <path d="M13.9978 3.1275C14.437 3.28229 14.8175 3.56959 15.0865 3.94976C15.3556 4.32993 15.5001 4.78424 15.5 5.25V14.25C15.5 14.8467 15.2629 15.419 14.841 15.841C14.419 16.2629 13.8467 16.5 13.25 16.5H5.75C5.15326 16.5 4.58097 16.2629 4.15901 15.841C3.73705 15.419 3.5 14.8467 3.5 14.25V5.25C3.49992 4.78424 3.64438 4.32993 3.91346 3.94976C4.18254 3.56959 4.56296 3.28229 5.00225 3.1275C5.03513 3.90046 5.36535 4.63083 5.92395 5.16609C6.48255 5.70135 7.22635 6.00012 8 6H11C11.7434 6.00007 12.4603 5.72414 13.0118 5.22571C13.5633 4.72727 13.9101 4.04183 13.985 3.30225L13.9978 3.1275ZM11.75 11.25H7.25C7.05109 11.25 6.86032 11.329 6.71967 11.4697C6.57902 11.6103 6.5 11.8011 6.5 12C6.5 12.1989 6.57902 12.3897 6.71967 12.5303C6.86032 12.671 7.05109 12.75 7.25 12.75H11.75C11.9489 12.75 12.1397 12.671 12.2803 12.5303C12.421 12.3897 12.5 12.1989 12.5 12C12.5 11.8011 12.421 11.6103 12.2803 11.4697C12.1397 11.329 11.9489 11.25 11.75 11.25ZM11.75 8.25H7.25C7.05109 8.25 6.86032 8.32902 6.71967 8.46967C6.57902 8.61032 6.5 8.80109 6.5 9C6.5 9.19891 6.57902 9.38968 6.71967 9.53033C6.86032 9.67098 7.05109 9.75 7.25 9.75H11.75C11.9489 9.75 12.1397 9.67098 12.2803 9.53033C12.421 9.38968 12.5 9.19891 12.5 9C12.5 8.80109 12.421 8.61032 12.2803 8.46967C12.1397 8.32902 11.9489 8.25 11.75 8.25ZM11 1.5C11.3978 1.5 11.7794 1.65804 12.0607 1.93934C12.342 2.22064 12.5 2.60218 12.5 3C12.5 3.39782 12.342 3.77936 12.0607 4.06066C11.7794 4.34196 11.3978 4.5 11 4.5H8C7.60218 4.5 7.22064 4.34196 6.93934 4.06066C6.65804 3.77936 6.5 3.39782 6.5 3C6.5 2.60218 6.65804 2.22064 6.93934 1.93934C7.22064 1.65804 7.60218 1.5 8 1.5H11Z" fill="#6366F1" />
                                <path d="M13.9978 3.1275C14.437 3.28229 14.8175 3.56959 15.0865 3.94976C15.3556 4.32993 15.5001 4.78424 15.5 5.25V14.25C15.5 14.8467 15.2629 15.419 14.841 15.841C14.419 16.2629 13.8467 16.5 13.25 16.5H5.75C5.15326 16.5 4.58097 16.2629 4.15901 15.841C3.73705 15.419 3.5 14.8467 3.5 14.25V5.25C3.49992 4.78424 3.64438 4.32993 3.91346 3.94976C4.18254 3.56959 4.56296 3.28229 5.00225 3.1275C5.03513 3.90046 5.36535 4.63083 5.92395 5.16609C6.48255 5.70135 7.22635 6.00012 8 6H11C11.7434 6.00007 12.4603 5.72414 13.0118 5.22571C13.5633 4.72727 13.9101 4.04183 13.985 3.30225L13.9978 3.1275ZM11.75 11.25H7.25C7.05109 11.25 6.86032 11.329 6.71967 11.4697C6.57902 11.6103 6.5 11.8011 6.5 12C6.5 12.1989 6.57902 12.3897 6.71967 12.5303C6.86032 12.671 7.05109 12.75 7.25 12.75H11.75C11.9489 12.75 12.1397 12.671 12.2803 12.5303C12.421 12.3897 12.5 12.1989 12.5 12C12.5 11.8011 12.421 11.6103 12.2803 11.4697C12.1397 11.329 11.9489 11.25 11.75 11.25ZM11.75 8.25H7.25C7.05109 8.25 6.86032 8.32902 6.71967 8.46967C6.57902 8.61032 6.5 8.80109 6.5 9C6.5 9.19891 6.57902 9.38968 6.71967 9.53033C6.86032 9.67098 7.05109 9.75 7.25 9.75H11.75C11.9489 9.75 12.1397 9.67098 12.2803 9.53033C12.421 9.38968 12.5 9.19891 12.5 9C12.5 8.80109 12.421 8.61032 12.2803 8.46967C12.1397 8.32902 11.9489 8.25 11.75 8.25ZM11 1.5C11.3978 1.5 11.7794 1.65804 12.0607 1.93934C12.342 2.22064 12.5 2.60218 12.5 3C12.5 3.39782 12.342 3.77936 12.0607 4.06066C11.7794 4.34196 11.3978 4.5 11 4.5H8C7.60218 4.5 7.22064 4.34196 6.93934 4.06066C6.65804 3.77936 6.5 3.39782 6.5 3C6.5 2.60218 6.65804 2.22064 6.93934 1.93934C7.22064 1.65804 7.60218 1.5 8 1.5H11Z" fill="black" fillOpacity="0.2" />
                            </g>
                            <defs>
                                <clipPath id="clip0_830_5367">
                                    <rect width="18" height="18" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        {t("propertyDetails.createPropertyReport")}
                    </button>
                    <DownloadProperty propertyId={property?._id} />
                    <Share propertyId={property?._id} />
                     {/* <PropertyWidget
                        images={property?.content?.images ? property.content.images.map((image: any) => image.src) : []}
                        onSave={handleImagesChange}
                    /> */}
                    {/* <DescriptionWidget /> */}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">
                        {property?.content?.description && <div className="dropdown">
                            <button
                                className="btn dropdown-toggle para-14 color-black bold-400"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <img src="/assets/images/icons/language-svgrepo-com.svg" width="21" className="marg-right-10" alt="lang" />
                                {selectedLang && selectedLang.charAt(0).toUpperCase() + selectedLang.slice(1)}
                                <svg width="14" height="15" viewBox="0 0 14 15" className="marg-left-5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_519_427)">
                                        <path d="M3.5 5.75L7 9.25L10.5 5.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_519_427">
                                            <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>

                            </button>

                            <ul className="dropdown-menu text-center" aria-labelledby="dropdownMenuButton">
                                {property?.content.description && property.content.description.map((language: any) => (
                                    <li key={language.lang}>
                                        <button
                                            className="dropdown-item text-center"
                                            onClick={() => setSelectedLang(language.lang)}
                                        >
                                            {language.lang.charAt(0).toUpperCase() + language.lang.slice(1)}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>}
                        <div className="marg-left-auto">
                            <EditListing property={property ?? {}} onUpdateProperty={UpdatePropertyHandler} />
                        </div>
                    </div>
                    <div className="sliderProp">
                        <ListImageGallery images={property?.content?.images} />
                    </div>
                    <PropertyDesc property={property ?? {}} lang={selectedLang} />
                </div>
            </div>

            <Snackbar open={openSnackbar} onClose={handleCloseSnackbar}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>

            <BootstrapDialog
                onClose={() => setShowUpgrade(false)}
                aria-labelledby="customized-dialog-title"
                open={showUpgrade}
                fullWidth={true}
                maxWidth="lg"
            >
                <IconButton
                    aria-label="close"
                    onClick={() => setShowUpgrade(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="padd-20" >
                        <UpgradeDetails />
                    </div>
                </DialogContent>
            </BootstrapDialog>
            
        </div>
    )

}
export default PropertyDetails;